
let soketSendArr = [{
    label: "进入发射功率",
    model: "16DF0402010100fD",
  },
  {
    label: "退出发射功率",
    model: "16DF04020110000C",
  },
  {
    label: "加大发射功率",
    model: "16DF04020112000e",
  },
  {
    label: "减少发射功率",
    model: "16DF04020121001d",
  },
  {
    label: "开始盘存",
    model: "16DF040201340030",
  },
  {
    label: "停止盘存",
    model: "16DF040201350031",
  },
  {
    label: "清空缓存",
    model: "16DF04020190008C",
  },
  {
    label: "开始收银",
    model: "16DF040201880084",
  },
  {
    label: "结束收银",
    model: "16DF040201890085",
  },

  // {
  //   label: "发射功率查询",
  //   model: "16DF04020191008d",
  // },
]

let modelFulter = function (str) {
  // 1、判断他们帧头是否准确

  if (str.substr(0, 4) === "16DF") {
    // 2、获取他们的数据值长度,转为10进制进行比对
    // let strLen = parseInt(str.substr(4, 2), 16);
    // 判断他们的数据长度
    // 3、判断他们传递的数据
    // let model = str.substring(6, str.length - 2).length/2;

    if (
      parseInt(str.substr(4, 2), 16) ==
      str.substring(6, str.length - 2).length / 2
    ) {
      // 数据长度相同的数据
      // 计算 SUM 数据是否
      if (

        verification(str.substr(0, str.length - 2)) ==
        str.substr(str.length - 2)
      ) {
        return str.substring(12, str.length - 4)
      }
    } else {
      // 数据长度不同的数据
    }
  }
}
let verification = function (source) {
  let count = 2;
  // source原始数据
  // count  截取的长度
  let num = 0;
  for (let i = 0, len = source.length / count; i < len; i++) {
    let subStr = source.substr(0, count);

    num += parseInt(subStr, 16);
    source = source.replace(subStr, "");
  }
  let cc =
    num.toString(16).length >= 2 ?
    num.toString(16).substr(-2) :
    num.toString(16).length < 2 ?
    "0" + num.toString(16) :
    num.toString(16);
  return cc.toUpperCase();
}
let numFulter = function (num) {
  return num.toString(16).toUpperCase().length == 1 ?
    "0" + num.toString(16).toUpperCase() :
    num.toString(16).toUpperCase();
}
export {
  verification,
  numFulter,
  modelFulter,
}